/**
 * Affra wordmark logo — SVG-based so it scales perfectly with any `size` class
 * (e.g. h-8, h-14, h-28) while preserving stroke weight and kerning.
 * The dot is inline with the wordmark for a tight, readable mark at any size.
 */
export function Logo({ className = "", size = "h-10" }) {
  return (
    <svg
      viewBox="0 0 240 80"
      xmlns="http://www.w3.org/2000/svg"
      className={`${size} w-auto select-none ${className}`}
      role="img"
      aria-label="Affra"
      data-testid="brand-logo"
      preserveAspectRatio="xMinYMid meet"
    >
      <text
        x="0"
        y="62"
        fontFamily="'Cabinet Grotesk','Inter',system-ui,sans-serif"
        fontWeight="900"
        fontSize="72"
        letterSpacing="-3"
        fill="#0A0A0A"
      >
        Affra<tspan fill="#4338CA">.</tspan>
      </text>
    </svg>
  );
}

export default Logo;
